var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm text-gray leading-4",attrs:{"data-testid":"filteredFitment"}},[_c('span',[_vm._v(_vm._s(_vm.fitmentFormatted))]),(_vm.fitmentFormattedSecondary)?_c('span',[_vm._v(", "+_vm._s(_vm.fitmentFormattedSecondary))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }